import React from "react";
import { Box, Typography, Button, Badge } from "@mui/material";
import { styled } from "@mui/material/styles";
import { orange, common } from "@/theme/colors";
import IndexPageHeader from "@/components/Importable/IndexPageHeader";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const HeaderSection = styled(Box)(({
  theme
}) => ({
  marginBottom: theme.spacing(6),
  paddingTop: theme.spacing(4)
}));
const OrganizationDirectoryHeader = ({
  hasPendingForUser,
  hasRejectedForUser,
  pendingCount,
  rejectedCount,
  submissionStatusLabel,
  isAdmin,
  onCreateClick,
  onCreateCsvClick,
  onSubmissionStatusClick,
  style = 1,
  showCreate = true,
  showUpload = true
}) => {
  const statusActive = hasPendingForUser || hasRejectedForUser;
  // Anything but the native directory look goes through the shared
  // header, which owns all three styles.
  if (style !== 1 || !showCreate || !showUpload) {
    return /*#__PURE__*/_jsx(IndexPageHeader, {
      style: style,
      accent: {
        primary: orange.primary,
        dark: orange.dark
      },
      title: "Organizations Directory",
      subtitle: "Discover leading organizations, consulting firms, and certification services in the compliance and product safety industry.",
      ariaLabel: "Organizations Directory Header",
      isAdmin: isAdmin,
      create: showCreate ? {
        label: "Add Your Organization",
        onClick: onCreateClick,
        badge: statusActive ? {
          count: hasRejectedForUser ? rejectedCount : pendingCount,
          color: hasRejectedForUser ? "error" : "info"
        } : null
      } : undefined,
      upload: showUpload ? {
        label: "Add by CSV",
        onClick: onCreateCsvClick,
        adminOnly: true
      } : undefined,
      status: statusActive ? {
        label: submissionStatusLabel,
        onClick: onSubmissionStatusClick
      } : undefined
    });
  }
  return /*#__PURE__*/_jsxs(HeaderSection, {
    "aria-label": "Organizations Directory Header",
    "data-select-target": "Organizations Directory Header",
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        flexWrap: "wrap"
      },
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h2",
        component: "h1",
        sx: {
          m: 0,
          flex: "1 1 auto",
          fontWeight: 400
        },
        children: "Organizations Directory"
      }), /*#__PURE__*/_jsx(Box, {
        sx: {
          flex: "0 0 auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: 0.5
        },
        children: /*#__PURE__*/_jsxs(Box, {
          sx: {
            display: "flex",
            alignItems: "flex-start",
            gap: 1,
            flexWrap: "wrap",
            justifyContent: "flex-end",
            maxWidth: "100%"
          },
          children: [/*#__PURE__*/_jsxs(Box, {
            sx: {
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              gap: 0.5
            },
            children: [/*#__PURE__*/_jsx(Badge, {
              color: hasPendingForUser ? "info" : "error",
              badgeContent: hasPendingForUser ? pendingCount : rejectedCount,
              invisible: !(hasPendingForUser || hasRejectedForUser),
              children: /*#__PURE__*/_jsx(Button, {
                variant: "contained",
                size: "large",
                onClick: onCreateClick,
                sx: {
                  bgcolor: orange.primary,
                  whiteSpace: "nowrap",
                  "&:hover": {
                    bgcolor: orange.dark
                  }
                },
                children: "Add Your Organization"
              })
            }), hasPendingForUser || hasRejectedForUser ? /*#__PURE__*/_jsx(Button, {
              variant: "text",
              color: hasPendingForUser ? "info" : "error",
              size: "small",
              onClick: onSubmissionStatusClick,
              sx: {
                textTransform: "none",
                fontWeight: 600,
                p: 0,
                minHeight: "auto"
              },
              children: submissionStatusLabel
            }) : null]
          }), isAdmin && /*#__PURE__*/_jsx(Button, {
            variant: "outlined",
            size: "large",
            onClick: onCreateCsvClick,
            sx: {
              whiteSpace: "nowrap",
              display: {
                xs: "none",
                md: "inline-flex"
              },
              borderColor: orange.primary,
              color: orange.primary,
              backgroundColor: common.white,
              "&:hover": {
                borderColor: orange.dark,
                color: orange.dark,
                bgcolor: common.white
              }
            },
            children: "Add by CSV"
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "h6",
      color: "text.secondary",
      paragraph: true,
      sx: {
        mt: 1,
        fontWeight: 400
      },
      children: "Discover leading organizations, consulting firms, and certification services in the compliance and product safety industry."
    })]
  });
};
export default OrganizationDirectoryHeader;